module.exports = __webpack_public_path__ + "static/media/LucidaGrande.da306d2b.woff";